import React from "react";

export default function HeroSection({ title, description, bgColor, image }) {
  return (
    <div className={`py-20 ${bgColor} relative`}>
      <div className="max-w-7xl mx-auto px-4 text-center">
        <h1 className="text-4xl font-bold text-white mb-4 mt-[40px] ">
          {title}
        </h1>
        <i className="text-xl text-gray-200  ">{description}</i>
      </div>
    </div>
  );
}
